<template>
	<div class="app-container gamesType">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>

			<!-- <el-button type="primary" icon="el-icon-plus" @click="handleAdd" class="mb20">添加赛事类型</el-button> -->
			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="赛事类型名称" align="center" prop="gameTypeName" />
				<el-table-column label="添加人" align="center" prop="createBy" />
				<el-table-column label="添加时间" align="center" prop="createTime"></el-table-column>
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="success" @click="handleList(scope.row)">赛事项目管理</el-button>
						<!-- <el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button> -->
						<!-- <el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />
		</el-card>
		<el-dialog :title="dialogTit" :visible.sync="dialogShow" width="600px" append-to-body>
			<el-form ref="setform" :model="setParams" size="mini" :rules="rules">
				<el-form-item label="赛事类型名称" prop="gameTypeName">
					<el-input clearable size="small" style="width: 400px" placeholder="请输入赛事类型名称"
						v-model="setParams.gameTypeName" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="cancel">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import * as API_Game from "@/api/sportManage/game";
	import * as API_minApp from "@/api/sportManage/minapp";
	export default {
		name: "gamesType",
		data() {
			return {
				pageName: '赛事类型列表',
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false,

				dialogTit: "编辑赛事类型",
				setParams: {},
				rules: {
					gameTypeName: [{
						required: true,
						message: "请输入赛事类型名称",
						trigger: "change"
					}],
				},
				dialogShow: false,
			};
		},
		created() {
			this._getList()
		},
		methods: {
			// 接口-赛事类型列表
			_getList() {
				this.loading = true
				API_Game.typeList(this.queryParams).then((res) => {
					console.log(res.data);
					this.loading = false
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			// 接口-新增赛事类型
			_addType() {
				API_Game.addType(this.setParams).then((res) => {
					console.log(res.data);
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},
			// 接口-编辑赛事类型
			_editType() {
				API_Game.editType(this.setParams).then((res) => {
					console.log(res.data);
					this.$message({
						message: "操作成功",
						type: "success",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},
			// 接口-删除赛事类型
			_delType(id) {
				API_Game.delType(id).then((res) => {
					console.log(res.data);
					this.$message({
						message: "已删除",
					});
					this.handleRefresh()
				}).catch((err) => {

				});
			},

			handleList(row) {
				this.$router.push({
					path: "/sportManage/games/project",
					query: {
						id: row.id,
						name: row.gameTypeName
					},
				});
			},
			handleRefresh() {
				this.queryParams.pageNum = 1;
				this._getList();
			},

			handleAdd() {
				this.dialogShow = true;
				this.clear()
				this.setParams = {};
				this.dialogTit = '添加赛事类型'
			},
			handleEdit(row) {
				this.dialogShow = true
				this.clear();
				this.dialogTit = '编辑赛事类型'
				this.setParams = JSON.parse(JSON.stringify(row));
			},
			handleDel(row) {
				console.log(row);
				this.$confirm(`确定删除赛事类型“${row.gameTypeName}”？`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this._delType(row.id)
					})
					.catch(() => {});
			},
			submitForm() {
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this.dialogShow = false
						this.clear()
						this.setParams.id ? this._editType() : this._addType()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},
			// 弹窗-取消
			cancel() {
				this.setParams = {}
				this.dialogShow = false
				this.clear()
			},
			clear() {
				this.$nextTick(() => {
					this.$refs['setform'].clearValidate();
				})
			}
		},
	};
</script>

<style lang="scss">
	.gamesType {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>


<style lang="scss">
	@import "../../../assets/styles/common.scss";
</style>